import produce from 'immer';
import * as actions from './actions';

export const initialState = {
  contact: { data: null, loading: false, error: null },
  contacts: { data: null, loading: false, error: null },
  contactsCount: { data: null, loading: false, error: null },
  allContacts: { data: null, loading: false, error: null },
  groups: { data: null, loading: false, error: null },
  creationTask: { data: null, loading: false, error: null },
  updateTask: { data: null, loading: false, error: null },
  updated: { data: {}, loading: {}, error: {} },
  contactsDeleted: { data: null, loading: false, error: null },
  failedContactsDeletedId: [],
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.FETCH_CONTACT_REQUEST:
      draft.contact.loading = true;
      break;
    case actions.FETCH_CONTACT_SUCCESS:
      draft.contact.loading = false;
      draft.contact.data = action.payload.contact;
      break;
    case actions.FETCH_CONTACT_FAILURE:
      draft.contact.loading = false;
      draft.contact.error = action.payload.error;
      break;
    case actions.UPDATE_CONTACT_REQUEST:
      draft.updateTask.loading = true;
      break;
    case actions.UPDATE_CONTACT_SUCCESS:
      draft.updateTask.loading = false;
      draft.updateTask.data = true;
      draft.contact.data = action.payload.contact;
      break;
    case actions.UPDATE_CONTACT_FAILURE:
      draft.updateTask.loading = false;
      draft.updateTask.error = action.payload.error;
      break;
    case actions.DELETE_CONTACTS_REQUEST:
      draft.contactsDeleted.loading = true;
      break;
    case actions.DELETE_CONTACTS_SUCCESS:
      draft.contactsDeleted.loading = false;
      draft.contactsDeleted.data = true;
      draft.contact.data = action.payload.contact;
      break;
    case actions.DELETE_CONTACTS_FAILURE:
      draft.contactsDeleted.loading = false;
      draft.contactsDeleted.error = action.payload.error;
      break;
    case actions.DELETE_CONTACTS_ALL_REQUEST:
      draft.contactsDeleted.loading = true;
      break;
    case actions.DELETE_CONTACTS_ALL_SUCCESS:
      draft.contactsDeleted.loading = false;
      draft.contactsDeleted.data = true;
      break;
    case actions.DELETE_CONTACTS_ALL_FAILURE:
      draft.contactsDeleted.loading = false;
      draft.contactsDeleted.error = action.payload.error;
      break;
    case actions.FETCH_CONTACTS_REQUEST:
      draft.contacts.loading = true;
      break;
    case actions.FETCH_CONTACTS_SUCCESS:
      draft.contacts.loading = false;
      draft.contacts.data = action.payload.contacts;
      break;
    case actions.FETCH_CONTACTS_FAILURE:
      draft.contacts.loading = false;
      draft.contacts.error = action.payload.error;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_SCHOOL_REQUEST:
      draft.allContacts.loading = true;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_SCHOOL_SUCCESS:
      draft.allContacts.loading = false;
      draft.allContacts.data = action.payload.allContacts;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_SCHOOL_FAILURE:
      draft.allContacts.loading = false;
      draft.allContacts.error = action.payload.error;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_REQUEST:
      draft.allContacts.loading = true;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_SUCCESS:
      draft.allContacts.loading = false;
      draft.allContacts.data = action.payload.allContacts;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_FAILURE:
      draft.allContacts.loading = false;
      draft.allContacts.error = action.payload.error;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_REQUEST:
      draft.allContacts.loading = true;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_SUCCESS:
      draft.allContacts.loading = false;
      draft.allContacts.data = action.payload.allContacts;
      break;
    case actions.FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_FAILURE:
      draft.allContacts.loading = false;
      draft.allContacts.error = action.payload.error;
      break;
    case actions.FETCH_CONTACTS_BY_CLAZZ_GROUP_REQUEST:
      draft.contacts.loading = true;
      break;
    case actions.FETCH_CONTACTS_BY_CLAZZ_GROUP_SUCCESS:
      draft.contacts.loading = false;
      draft.contacts.data = action.payload.contacts;
      break;
    case actions.FETCH_CONTACTS_BY_CLAZZ_GROUP_FAILURE:
      draft.contacts.loading = false;
      draft.contacts.error = action.payload.error;
      break;
    case actions.FETCH_CONTACTS_BY_CUSTOM_GROUP_REQUEST:
      draft.contacts.loading = true;
      break;
    case actions.FETCH_CONTACTS_BY_CUSTOM_GROUP_SUCCESS:
      draft.contacts.loading = false;
      draft.contacts.data = action.payload.contacts;
      break;
    case actions.FETCH_CONTACTS_BY_CUSTOM_GROUP_FAILURE:
      draft.contacts.loading = false;
      draft.contacts.error = action.payload.error;
      break;
    case actions.FETCH_CONTACTS_COUNT_REQUEST:
      draft.contactsCount.loading = true;
      break;
    case actions.FETCH_CONTACTS_COUNT_SUCCESS:
      draft.contactsCount.loading = false;
      draft.contactsCount.data = action.payload.contactsCount;
      break;
    case actions.FETCH_CONTACTS_COUNT_FAILURE:
      draft.contactsCount.loading = false;
      draft.contactsCount.error = action.payload.error;
      break;
    case actions.FETCH_GROUPS_REQUEST:
      draft.groups.loading = true;
      break;
    case actions.FETCH_GROUPS_SUCCESS:
      draft.groups.loading = false;
      draft.groups.data = action.payload.groups;
      break;
    case actions.FETCH_GROUPS_FAILURE:
      draft.groups.loading = false;
      draft.groups.error = action.payload.error;
      break;
    case actions.CREATE_CLAZZ_GROUP_REQUEST:
      draft.creationTask.loading = true;
      break;
    case actions.CREATE_CLAZZ_GROUP_SUCCESS:
      draft.creationTask.loading = false;
      draft.creationTask.data = true;
      draft.groups.data.clazzGroups.push(action.payload.clazzGroup);
      break;
    case actions.CREATE_CLAZZ_GROUP_FAILURE:
      draft.creationTask.loading = false;
      draft.creationTask.error = action.payload.error;
      break;
    case actions.CREATE_CUSTOM_GROUP_REQUEST:
      draft.creationTask.loading = true;
      break;
    case actions.CREATE_CUSTOM_GROUP_SUCCESS:
      draft.creationTask.loading = false;
      draft.creationTask.data = true;
      draft.groups.data.customGroups.push(action.payload.customGroup);
      break;
    case actions.CREATE_CUSTOM_GROUP_FAILURE:
      draft.creationTask.loading = false;
      draft.creationTask.error = action.payload.error;
      break;
    case actions.UPDATE_CUSTOM_GROUP_REQUEST:
      draft.updateTask.loading = true;
      break;
    case actions.UPDATE_CUSTOM_GROUP_SUCCESS:
      draft.updateTask.loading = false;
      draft.updateTask.data = true;
      break;
    case actions.UPDATE_CUSTOM_GROUP_FAILURE:
      draft.updateTask.loading = false;
      draft.updateTask.error = action.payload.error;
      break;
    case actions.EXCHANGE_GUARDIAN_CONTACTS_REQUEST:
      draft.updateTask.loading = true;
      break;
    case actions.EXCHANGE_GUARDIAN_CONTACTS_SUCCESS:
      draft.updateTask.loading = false;
      draft.updateTask.data = true;
      draft.contact.data.primary_guardian_contact = action.payload.primaryGuardianContact;
      draft.contact.data.secondary_guardian_contact = action.payload.secondaryGuardianContact;
      break;
    case actions.EXCHANGE_GUARDIAN_CONTACTS_FAILURE:
      draft.updateTask.loading = false;
      draft.updateTask.error = action.payload.error;
      break;
    case actions.APPLY_CHANGED_GROUPS_REQUEST:
      draft.updated.loading.groups = true;
      break;
    case actions.APPLY_CHANGED_GROUPS_SUCCESS:
      draft.updated.loading.groups = false;
      draft.updated.data.groups = true;
      draft.groups.data = action.payload.groups;
      break;
    case actions.APPLY_CHANGED_GROUPS_FAILURE:
      draft.updated.loading.groups = false;
      draft.updated.error.groups = action.payload.error;
      break;
    case actions.CLEAR_ALL_CONTACTS_ERROR:
      draft.allContacts.error = null;
      break;
    case actions.CLEAR_CONTACTS_ERROR:
      draft.contacts.error = null;
      break;
    case actions.CLEAR_CONTACTS_COUNT_ERROR:
      draft.contactsCount.error = null;
      break;
    case actions.CLEAR_GROUPS_ERROR:
      draft.groups.error = null;
      break;
    case actions.PUSH_FAILED_CONTACTS_DELETED_ID:
      draft.failedContactsDeletedId.push(action.payload.contactId);
      break;
    case actions.CLEAR_FAILED_CONTACTS_DELETED_ID:
      draft.failedContactsDeletedId = [];
      break;
    case actions.CLEAR_CONTACTS_DELETED_ERROR:
      draft.contactsDeleted.error = null;
      break;
    case actions.INIT_CONTACT:
      draft.contact = { data: null, loading: false, error: null };
      break;
    case actions.INIT_CONTACTS:
      draft.contacts = { data: null, loading: false, error: null };
      break;
    case actions.INIT_ALL_CONTACTS:
      draft.allContacts = { data: null, loading: false, error: null };
      break;
    case actions.INIT_CREATION_TASK:
      draft.creationTask = { data: null, loading: false, error: null };
      break;
    case actions.INIT_UPDATE_TASK:
      draft.updateTask = { data: null, loading: false, error: null };
      break;
    case actions.INIT_UPDATED:
      draft.updated = { data: {}, loading: {}, error: {} };
      break;
    case actions.INIT_CONTACTS_DELETED:
      draft.contactsDeleted = { data: null, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
